import { loadStripe } from "@stripe/stripe-js";
import api from "../libs/api";
import _ from "lodash";

export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export async function stripeTokenHandler(token, firstCard = false) {
  const { data } = await api.put("/clients/card", {
    stripeTokenId: token.id,
    firstCard,
    last4: _.get(token, "card.last4", "****"),
  });
  return data;
}
